export const getSortByTimeButtonText = (timeSortOrder: 'asc' | 'desc' | null) => {
    if (timeSortOrder === "desc") return "Sorted: Newest First";
    if (timeSortOrder === "asc") return "Sorted: Oldest First";
    return "Sort by Time";
  };